import imagePickerChoiceView from './imagePickerChoicesComponent.html';
import './imagePickerChoicesComponent.css';

export function imagePickerChoicesComponent() {
	return {
		bindings: {
			model: '=',
			images: '<',
			height: '<?',
		},
		controllerAs: 'vm',
		controller: imagePickerChoicesComponentCtrl,
		template: imagePickerChoiceView,
	};
}

export class imagePickerChoicesComponentCtrl {
	constructor(modal) {
		'ngInject';
		this.modal = modal;
	}

	$onInit() {
		this.height = this.height || 120;
	}

	choose(image) {
		this.model = image;
	}
}
